<template>
    <section class="msger" v-if="loaded">
  <header class="msger-header">
    <div class="msger-header-title">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:middle;margin-inline-end:6px"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> צ'אט בשידור חי
    </div>
                <div v-if="!active" class="upgrade" @click="$emit('open_pay')">שדרוג למנוי פרימיום</div>

    <!-- <div class="msger-header-options">
      <span><i class="fas fa-cog"></i></span>
    </div> -->
  </header>

  <main class="msger-chat" ref="msgerchat">
    <!-- <div class="msg left-msg">
      <div
       class="msg-img"
       style="background-image: url(https://image.flaticon.com/icons/svg/327/327779.svg)"
      ></div>

      <div class="msg-bubble">
        <div class="msg-info">
          <div class="msg-info-name">מנהל האתר</div>
          <div class="msg-info-time">12:45</div>
        </div>

        <div class="msg-text">
        היי ברוכים הבאים לאתר TOVTV
        </div>
      </div>
    </div> -->

    <div class="msg right-msg" v-for="item in items" :key="item.id">
      <div
       class="msg-img"
       style="background-image: url(https://image.flaticon.com/icons/svg/145/145867.svg)"
      ></div>

      <div class="msg-bubble">
        <div class="msg-info">
          <div class="msg-info-name">{{item.user}}  </div>
          <div class="msg-info-time">{{parse_time(item.date_created)}}</div>
        </div>

        <div class="msg-text">
         {{item.content}}
        </div>
      </div>
    </div>

  </main>

  <form class="msger-inputarea" @submit.prevent="send_msg()">
    <label for="msger-input-id" class="sr-only">הקלד הודעה</label>
    <input id="msger-input-id" type="text" class="msger-input" placeholder="מה תרצה לשאול?..." v-model="msg" aria-label="הקלד הודעה">
    <button type="submit" class="msger-send-btn">שלח</button>
  </form>
</section>
</template>
<script>
export default {
  props:["episode","active"],
  data(){
    return{
      loaded:false,
      msg:'',
      items:{}
    }
    },
    methods:{
        send_msg()
        {
            var self = this;
            if(!this.isNull(this.msg))
            {
            this.api_call({ url: 'send_msg', data: { uid: this.$store.user.id, episode_id: this.episode.id,content:this.msg }, onComplete: function(data){
                      self.data = data.data
                    }});

                    this.msg = ''
            }
        

        },


        
        scroll() {  
        
          let objDiv = this.$refs.msgerchat;

          objDiv.scrollTop = objDiv.scrollHeight
      //  elmnt.scrollIntoView({behavior:'smooth'});
        },
          

        
    parse_user_channel(msg)
    {
      var data = JSON.parse(msg.message);
      // console.log(data);

      switch(data.mtype)
      {
        case 'chat_msg': { 
            this.items.push({ content: data.data.msg, date_created: data.data.date_created, user: data.data.user });
           setTimeout(() => { this.scroll()},300)
            break;
        }
      }
    },


    },
    mounted(){
       var self = this;
            this.api_call({ url: 'get_msg', data: {  episode_id: this.episode.id }, onComplete: function(data){
              self.items = data.data.data
             
              self.loaded = true
            }})



            
        self.$pnSubscribe({ channels: ['item_cnl_' + this.episode.id] });
        self.$pnGetMessage('item_cnl_' + this.episode.id, self.parse_user_channel);
    }

}
</script>
<style scoped lang="scss">

.msger {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  width: 100%;
  max-width: 867px;
  margin-block: var(--space-6);
  margin-inline: var(--space-2);
  height: calc(100% - 50px);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  background: var(--color-surface1);
  font-family: var(--font-hebrew);
  box-shadow: var(--shadow-md);
}

.msger-header {
  display: flex;
  justify-content: space-between;
  padding: var(--space-2);
  border-block-end: 1px solid var(--color-border);
  background: var(--color-surface2);
  color: var(--color-textMuted);
}

.msger-chat {
  flex: 1;
  overflow-y: auto;
  padding: var(--space-2);
  background-color: var(--color-surface1);
}
.msger-chat::-webkit-scrollbar {
  width: 6px;
}
.msger-chat::-webkit-scrollbar-track {
  background: var(--color-surface3);
}
.msger-chat::-webkit-scrollbar-thumb {
  background: var(--color-surface4);
}
.msg {
  display: flex;
  align-items: flex-end;
  margin-block-end: var(--space-2);
}
.msg:last-of-type {
  margin: 0;
}
.msg-img {
  width: 50px;
  height: 50px;
  margin-inline-end: var(--space-2);
  background: var(--color-surface3);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
}
.msg-bubble {
  max-width: 450px;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  background: var(--color-surface2);
  color: var(--color-text);
  font-family: var(--font-hebrew);
}
.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block-end: var(--space-2);
}
.msg-info-name {
  margin-inline: var(--space-2);
  font-weight: bold;
}
.msg-info-time {
  font-size: 0.85em;
  color: var(--color-textMuted);
}

.right-msg .msg-info-time {
  color: rgba(255, 255, 255, 0.85);
}

.left-msg .msg-bubble {
  border-end-start-radius: 0;
}

.right-msg {
  flex-direction: row-reverse;
}
.right-msg .msg-bubble {
  background: var(--color-accent);
  color: var(--color-text);
  border-end-end-radius: 0;
}
.right-msg .msg-img {
  margin-inline: 0 var(--space-2);
}

.msger-inputarea {
  display: flex;
  padding: var(--space-2);
  border-block-start: 1px solid var(--color-border);
  background: var(--color-surface2);
}
.msger-inputarea * {
  padding: var(--space-2);
  border: none;
  border-radius: var(--radius-sm);
  font-size: 1em;
  font-family: var(--font-hebrew);
}
.msger-input {
  flex: 1;
  background: var(--color-surface3);
  color: var(--color-text);
}
.msger-send-btn {
  margin-inline-start: var(--space-2);
  background: var(--color-accent);
  color: var(--color-text);
  font-weight: bold;
  cursor: pointer;
  transition: background var(--duration-fast) var(--easing-default);
}
.msger-send-btn:hover {
  background: var(--color-accentHover);
}
.msger-send-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.upgrade { cursor: pointer; background: var(--color-accent); color: var(--color-text); padding: var(--space-1) var(--space-4); border-radius: var(--radius-pill); font-weight: 600; min-height: 44px; display: inline-flex; align-items: center; justify-content: center; }
@media (prefers-reduced-motion: no-preference) {
  .upgrade:hover { transform: scale(1.05); transition: var(--duration-fast) all var(--easing-default); }
}
@media (prefers-reduced-motion: reduce) {
  .upgrade:hover { transform: none; }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>